import BaseApplication from "./base.js";

("use strict");

export class Application extends BaseApplication {
    constructor(args = []) {
        super(args);

        this.setLog("[Extension] ", "Worship Guide");

        this.setInteractiveMap();
    }

    callback() {
        this.showPerfomance();
        return null;
    }

    setInteractiveMap() {
        const self = this;

        this.mapping = {
            current: null,
            initialized: false,
            target: null,
            wrapper: null,
            display: {
                wrapper: null,
                target: null,
                overlay: null,
            },
            list: [],
        };

        this.mapping.target = document.getElementById("illustMap");
        if (!this.isEmpty(this.mapping.target)) {
            this.mapping.wrapper =
                this.mapping.target.getElementsByClassName("map-wrapper")[0];
            this.mapping.selector =
                this.mapping.target.getElementsByClassName("map-selector")[0];

            this.mapping.display.wrapper =
                document.getElementsByClassName("map-display")[0];
            this.mapping.display.target =
                this.mapping.display.wrapper.getElementsByClassName(
                    "map-display-content"
                )[0];
            this.mapping.display.overlay =
                this.mapping.display.wrapper.getElementsByClassName(
                    "map-display-overlay"
                )[0];

            if (
                !this.isEmpty(this.mapping.selector) &&
                !this.isEmpty(this.mapping.wrapper) &&
                !this.isEmpty(this.mapping.display.wrapper) &&
                !this.isEmpty(this.mapping.display.target) &&
                !this.isEmpty(this.mapping.display.overlay)
            ) {
                this._selectors.mapItems =
                    this.mapping.selector.querySelectorAll("[data-item]");
                [].forEach.call(this._selectors.mapItems, function (mapItem) {
                    var mapData = {
                        target: mapItem.getAttribute("data-item"),
                        targetElement: null,
                        title: mapItem.getAttribute("title"),
                        element: mapItem,
                    };

                    mapData.targetElement = document.getElementById(
                        mapData.target
                    );

                    mapItem.addEventListener("click", function (event) {
                        event.preventDefault();
                        self.triggerMapItem(mapData);
                    });

                    self.mapping.list.push(mapData);
                });

                this.mapping.display.overlay.addEventListener(
                    "click",
                    function (event) {
                        event.preventDefault();
                        self.closeMapItems();
                    }
                );

                var closeButtons =
                    this.mapping.display.wrapper.querySelectorAll(
                        "[data-close-items]"
                    );
                [].forEach.call(closeButtons, function (closeButton) {
                    closeButton.addEventListener("click", function (event) {
                        event.preventDefault();
                        self.closeMapItems();
                    });
                });

                this.mapping.initialized = true;
            }
        }
    }

    triggerMapItem(mapData) {
        if (mapData.targetElement != null) {
            if (this.mapping.current != mapData) {
                this.toggleClass("html", "is-clipped", true);
                this.toggleClass("body", "is-clipped", true);
                this.toggleClass(".viewport", "is-clipped", true);

                this.mapping.display.target.innerHTML =
                    mapData.targetElement.outerHTML;
                this.mapping.display.wrapper.classList.add("active");
                this.mapping.current = mapData;
            }
        } else {
            this.closeMapItems();
        }
    }

    closeMapItems() {
        this.toggleClass("html", "is-clipped", false);
        this.toggleClass("body", "is-clipped", false);
        this.toggleClass(".viewport", "is-clipped", false);

        this.mapping.current = null;
        this.mapping.display.wrapper.classList.remove("active");
    }
}

window.Application = new Application();
